import {
    DecisionCommandType,
    DecisionState,
    DecisionType,
} from '@/models/games/blackjack2/enums/DecisionState';
import { StateMsgType } from '@/models/Popup';
import { getHostByGameId } from '@/modules/host/slice';
import { inGamePopupSliceActions } from '@/modules/popup/inGameSlice';
import { bj2SeatSliceActions } from '@/modules/rwdGame/blackjack2/slice/seatSlice';
import store from '@/store/store';
import { Dispatch } from 'react';
import { batch } from 'react-redux';
import { AnyAction } from 'redux';
import { CMDSpNewBlackjackMakeDecision, ICommand } from '../live';
import { AbstractHandler } from './AbstractHandler';

export class CMDSpNewBlackjackMakeDecisionHandler extends AbstractHandler {
    _command: CMDSpNewBlackjackMakeDecision;
    _specialMsg: string;
    _isMessageExist: (key: string) => boolean;
    constructor(
        command: ICommand,
        specialMsg: string,
        isMessageExist: (key: string) => boolean
    ) {
        super();
        this._command = command as CMDSpNewBlackjackMakeDecision;
        this._specialMsg = specialMsg;
        this._isMessageExist = isMessageExist;
    }

    handle(dispatch: Dispatch<AnyAction>): void {
        const state = store.getState();
        const host = getHostByGameId(state, this._command.GameID);
        if (this._command.Type == DecisionCommandType.Pre_decision) {
            if (host) {
                dispatch(
                    bj2SeatSliceActions.updateSeatObject({
                        hostId: host.HostId,
                        seat: this._command.Seat,
                        PreDecision: this._command.Decision,
                    })
                );
            }
        } else if (this._command.Type == DecisionCommandType.FollowDecision) {
            if (this._command.Reason !== this.SUCCESS_CODE) {
                let errorMsg = `abc_failure_betlog.error_code.${this._command.Reason}`;
                if (!this._isMessageExist(errorMsg)) {
                    errorMsg = 'abc_failure_betlog.error_common';
                }
                batch(() => {
                    dispatch(
                        inGamePopupSliceActions.updateIsOpen({
                            hostId: host.HostId,
                            isOpen: true,
                        })
                    );
                    dispatch(
                        inGamePopupSliceActions.updateDataSet({
                            hostId: host.HostId,
                            key: errorMsg,
                            gameType: host.GameType,
                            stateMsgType: StateMsgType.betInfo_Fail,
                            gameId: this._command.GameID,
                            params: {
                                errorcode: this._command.Reason.toString(),
                            },
                        })
                    );
                });
            } else {
                if (host) {
                    dispatch(
                        bj2SeatSliceActions.updateSeatObject({
                            hostId: host.HostId,
                            seat: this._command.Seat,
                            DecisionState: DecisionState.NO_DECISION,
                        })
                    );
                }
            }
        }
        if (this._command.Decision == DecisionType.Insurance) {
            if (host) {
                dispatch(
                    bj2SeatSliceActions.updateDecisionStateStep({
                        hostId: host.HostId,
                        step: '',
                    })
                );
            }
        }
    }
}
